import type { CourseCard } from '@inflearn/course-card';
import type { ComponentProps } from 'react';

import {
  CourseType,
  OfflineCourseType,
  type UserProfileCourseResponse,
} from '../../../resources/@types/courseSchema';

export type UserProfileCourseDto = NonNullable<UserProfileCourseResponse['data']['items']>[number];

export function adaptToCourseCardListPriceProp(
  course: UserProfileCourseDto,
): ComponentProps<typeof CourseCard>['listPrice'] {
  return {
    ...course.listPrice,
  };
}

export function adaptToCourseCardPromotionProp(
  course: UserProfileCourseDto,
): ComponentProps<typeof CourseCard>['promotion'] {
  return course?.tagTitles[0]
    ? {
        type: 'COURSE',
        id: 0,
        course: {
          tagTitle: course.tagTitles[0],
          abilities: course.course.abilities,
          runtimeSecond: course.course.runtimeSecond,
        },
        url: undefined,
      }
    : undefined;
}

const LEVEL_WORD: Record<string, string> = {
  BEGINNER: '입문',
  BASIC: '초급',
  ADVANCED: '중급이상',
};

export const adaptToMixpanelCourse = (course: UserProfileCourseDto) => ({
  course_identification: String(course.id),
  course_level: LEVEL_WORD[course.course.metadata.level]
    ? [LEVEL_WORD[course.course.metadata.level]]
    : undefined,
  course_last_updated_date: course.course.updatedAt,
  course_published_date: course.course.publishedAt,
  course_title: course.course.title,
  course_type:
    course.type === CourseType.ON
      ? '온라인 강의'
      : course.offlineCourse?.type === OfflineCourseType.CONFERENCE
        ? '컨퍼런스/모임'
        : '부트캠프/교육',
  discount_id: course.listPrice.discountId ? String(course.listPrice.discountId) : undefined,
  discount_rate: course.listPrice.discountRate,
  discount_title: course.listPrice.discountTitle ?? undefined,
  first_category: course.course.metadata.parentCategories,
  second_category: course.course.metadata.childCategories,
  is_discount: course.listPrice.isDiscount,
  kdt_price: course.isKdt ? course.listPrice.regularPrice : undefined,
  reg_price: Math.round(course.listPrice.regularPrice / 1.1), // 원가(정가 / 1.1) 계산시 부동소숫점 이슈로 round 처리
  reg_vat_price: course.listPrice.regularPrice,
  review_count: course.course.reviewCount,
  like_count: course.course.likeCount,
  selling_price: course.listPrice.payPrice,
  seq0_instructor_id: course.instructor.id ? String(course.instructor.id) : undefined,
  seq0_instructor_name: course.instructor.name,
  skill_tag: course.course.metadata.skills,
  star_rate: course.course.star,
  student_count: course.course.studentCount,
});
